import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { updatePassword } from '../../services/authService';

const wrap = {
  minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)', color: '#fff',
  fontFamily: '"Poppins", sans-serif', padding: 24,
};
const card = { width: '100%', maxWidth: 420, background: '#151515', border: '1px solid #333', borderRadius: 12, padding: 28 };
const input = { width: '100%', padding: '12px 14px', borderRadius: 8, border: '1px solid #444', background: '#0f0f0f', color: '#fff', marginTop: 8 };
const btn = { width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: '#4c8bf5', color: '#fff', fontWeight: 600, cursor: 'pointer', marginTop: 16 };

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    // The Supabase recovery link establishes a session; updateUser sets the new password.
    const result = await updatePassword(password);
    setLoading(false);
    if (result.success) {
      navigate('/login');
    } else {
      setError(result.error || 'Could not update password. Please use the reset link again.');
    }
  };

  return (
    <div style={wrap}>
      <div style={card}>
        <h1 style={{ fontSize: 24, marginBottom: 8 }}>Choose a new password</h1>
        {error && <p style={{ color: '#ff6b6b', marginBottom: 12 }}>{error}</p>}
        <form onSubmit={submit}>
          <label htmlFor="password">New password</label>
          <input id="password" type="password" required style={input} value={password} onChange={(e) => setPassword(e.target.value)} />
          <label htmlFor="confirm" style={{ display: 'block', marginTop: 12 }}>Confirm password</label>
          <input id="confirm" type="password" required style={input} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          <button type="submit" style={btn} disabled={loading}>{loading ? 'Updating…' : 'Update password'}</button>
        </form>
        <p style={{ marginTop: 16, textAlign: 'center' }}><Link to="/login" style={{ color: '#4c8bf5' }}>Back to sign in</Link></p>
      </div>
    </div>
  );
}
